/* src/app/shared/components/ag-date-picker/ag-date-picker.component.scss */
.relative-container {
  width: fit-content;
  position: relative;
}
.date-picker {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 12px 16px;
  border-radius: 12px;
  background: #f2f2f2;
  max-height: 56px;
  font-size: 14px;
  font-family: "Poppins-Regular";
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  gap: 8px;
  width: 100%;
}
.text {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  margin: 0;
}
.grey-label {
  color: #5c5c5c;
}
.dark-label {
  color: #222222;
}
.wide {
  width: 260px;
}
.thin {
  width: 200px;
}
.date-picker-white {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 12px 16px;
  border-radius: 12px;
  background: #ffffff;
  position: relative;
  z-index: 5;
  height: 48px;
  max-height: 48px;
  font-size: 14px;
  font-family: "Poppins-Regular";
  cursor: pointer;
  border: 1px solid #222222;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  gap: 8px;
  width: 100%;
}
.info-text {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
}
.red-img {
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
.date-picker-box {
  margin-top: 4px;
  position: absolute;
}
/*# sourceMappingURL=ag-date-picker.component.css.map */
